<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle class="app-accent-lighter" cx="32" cy="42" r="28" />
  <path
    d="M36 8C20.56 8 8 20.56 8 36C8 51.44 20.56 64 36 64C51.44 64 64 51.44 64 36C64 20.56 51.44 8 36 8ZM36 61.3333C22.032 61.3333 10.6667 49.968 10.6667 36C10.6667 22.032 22.032 10.6667 36 10.6667C49.968 10.6667 61.3333 22.032 61.3333 36C61.3333 49.968 49.968 61.3333 36 61.3333Z"
    fill="#484B4D"
    stroke="#484B4D"
    stroke-width="0.3"
  />
  <path
    d="M49.7226 25.7259L31.9999 43.4486L22.2773 33.7233C21.7573 33.2033 20.912 33.2033 20.392 33.7233C19.872 34.2433 19.872 35.0886 20.392 35.6086L31.0586 46.2753C31.3173 46.5366 31.6586 46.6673 31.9999 46.6673C32.3413 46.6673 32.6826 46.5366 32.9439 46.2779L51.6106 27.6113C52.1306 27.0913 52.1306 26.2459 51.6106 25.7259C51.0906 25.2059 50.2453 25.2059 49.7226 25.7259Z"
    fill="#484B4D"
    stroke="#484B4D"
    stroke-width="0.3"
  />
</svg>
